import { Plugin } from 'prosemirror-state';

import { AddMenuImage, AddMenuImageHotspot, Image as IconImage } from '@lyearn/icons';
import { EditorOptions } from '@lyearn/lygo-core';

import { addMenuItemType } from '../../../types/menus';
import { addAddMenuBlock } from '../../../utils/menus';
import { NODE_NAME } from '../consts';
import ImageNodeView from './NodeView';

function plugins({ createReactNodeView, t, isMicroLearning }: EditorOptions) {
  const plugins = [
    new Plugin({
      props: {
        nodeViews: {
          image(node, view, getPos, decorations) {
            return createReactNodeView({
              node,
              view,
              getPos,
              decorations,
              isMicroLearning,
              component: ImageNodeView,
            });
          },
        },
      },
    }),

    new Plugin({
      view: (editorView) => {
        addAddMenuBlock(editorView, [
          {
            name: NODE_NAME,
            title: t('Lygo:Menu.image.title') as string,
            description: t('Lygo:Menu.image.description') as string,
            icon: IconImage,
            addMenuIcon: AddMenuImage,
            addMenuItemType: addMenuItemType.media,
            attrs: { src: null, alt: null },
            searchWords: ['image', 'media', 'upload'],
          },
          {
            name: NODE_NAME,
            title: t('Lygo:Menu.imagehotspot.title') as string,
            description: t('Lygo:Menu.imagehotspot.description') as string,
            icon: IconImage,
            addMenuIcon: AddMenuImageHotspot,
            addMenuItemType: addMenuItemType.interactive_blocks,
            attrs: { src: null, alt: null, hotspotsEnabled: true },
            searchWords: ['image', 'media', 'upload', 'hotspot'],
          },
        ]);
        return {};
      },
    }),
  ];
  return plugins;
}

export default plugins;
